import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'seb-accordion',
  templateUrl: './accordion.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  styleUrls: ['./accordion.component.css']
})
export class AccordionComponent implements OnInit {
  @Input() sTitlePrimary: String;
  @Input() sTitleSecond:  String;
  @Input() sTitleThird:  String;
  constructor() { }

  ngOnInit() {
  }
}
